import { Component, OnInit } from '@angular/core';
import { HeaderComponent } from '../../header/header.component';

@Component({
    selector: 'core-side-nav',
    templateUrl: './side-nav.component.html',
    standalone: false,
})
export class SideNavComponent extends HeaderComponent implements OnInit {
    override ngOnInit(): void {
        super.ngOnInit();

        this.openChildNav = null;
        this.hamburger = false;
        this.hamburgerChildNav = false;
        this.user = this.auth.getUser();
        this.isLoggedIn = this.auth.isAuthenticated();

        this.client.getAccessType().subscribe((type: any) => {
            this.authenticationType = type;
        });

        this.breakpoint.observe(['(max-width: 991px)']).subscribe(result => {
            this.isMobileNav = result.matches;
        });
    }

    menuStateCheck(menuState: boolean) {
        if (this.documentService.body) {
            this.documentService.body.style.overflowY = menuState ? 'revert' : 'hidden';
        }
    }
}
